"use client";

import useSWR from "swr";
import { fetcher } from "@/lib/api";

// 로그인 사용자가 볼 수 있는 페이지 (그 외는 메뉴/접근 제한)
export const RESTRICTED_ALLOWED_PATHS = ["/holding", "/risk", "/backtest", "/performance", "/trades", "/presets", "/etf", "/settings"];

/**
 * 현재 로그인 사용자 정보.
 * - user: 로그인 창으로 로그인한 사용자 id (없으면 null = 신뢰접근/비로그인 → 전체 권한)
 * - restricted: user 가 있으면 true (포트폴리오/메뉴 제한 적용)
 */
export function useAuthUser(): { user: string | null; restricted: boolean } {
  const { data } = useSWR<{ user: string | null }>("/api/auth/me", fetcher, {
    revalidateOnFocus: false,
    refreshInterval: 0,
  });
  const user = data?.user ?? null;
  return { user, restricted: !!user };
}
